import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { DialogModelImage } from './model';

@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss']
})
export class ImageComponent implements OnInit {

  loadError=false
  constructor(
    public dialogRef: MatDialogRef<ImageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogModelImage,
    ) { }


  ngOnInit(): void {
  }

  closeIt() {
    this.loadError=false
    this.dialogRef.close();
  }

  errorImage(event){
    if(event?.type==="error"){
       this.loadError=true
    }
  }

}
